import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import computer from 'assets/images/Tools-barcode-scanner-art.jpeg';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const FEATURE_DATA = [
  {
    id: 1,
    title:
      'Provide services to large groups of clients with one click of the scanner.',
  },
  {
    id: 2,
    title: 'Set reminders to reorder low inventory items',
  },
  {
    id: 3,
    title:
      'Guarantee return of unused inventory used in house assessments and inspections from contractors in programs such as Weatherization.',
  },
];
function BarcodeScanner() {
  return (
    <div>
      <Helmet>
        <title>Barcode Scanner - CAP60</title>
        <meta
          name="description"
          content="Cap60’s barcode scanner integration allows you to track inventory, attendance and services"
        />
        <meta name="keyword" content="barcode scanner, cap60 barcode scanner" />
      </Helmet>
      <PageBanner
        title="Track agency inventory and clients"
        subtitle="with the CAP60 Barcode Scanner"
      />
      <ClienDesk />
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>CAP60 Barcode Scanner</h2>
            </div>
            <p>
              CAP60’s Barcode Scanner Integration allows you to track inventory,
              attendance and staff more efficiently.
            </p>
            <p>
              You can also generate a wide range of reports based on the data
              collected from these scans. Some of the reports include:-
              inventory control, asset management and tracking, attendance,
              employee time stamps, food bank and clothing donations,
              demographic and statistics, restocking orders, and many more.
            </p>

            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image height={300} src={computer} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default BarcodeScanner;
